module.exports = __webpack_public_path__ + "static/media/ico-bookmark.7e2cca74.svg";